import * as React from "react";

export const SvgDeparture = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#a)" fill={props.color ?? "#A8A8A8"}>
			<path d="M19.384 16.57H.639a.616.616 0 0 0 0 1.233h18.745a.616.616 0 1 0 0-1.232ZM3.537 10.738c.153.186.4.266.632.205l4.08-1.07-.35 2.663a.616.616 0 0 0 .793.669l2.156-.664a.616.616 0 0 0 .33-.245l2.705-4.025 2.265-.938c1.258-.522 2.213-1.063 2.837-1.61 1.102-.966 1.055-1.839.822-2.4-.212-.514-.731-1.126-1.994-1.126-.87 0-2.024.295-3.43.877L5.36 6.811 2.763 4.973a.616.616 0 0 0-.593-.066l-1.791.748a.616.616 0 0 0-.238.96l3.396 4.124ZM2.33 6.175l2.595 1.839a.616.616 0 0 0 .593.066l9.337-3.867c1.238-.513 2.26-.784 2.958-.784.704 0 .814.265.856.365.042.103.172.416-.496 1.001-.516.452-1.38.936-2.497 1.399l-2.436 1.01a.616.616 0 0 0-.276.225l-2.688 3.998-1.03.318.343-2.621a.616.616 0 0 0-.767-.676L4.237 9.65 1.62 6.472l.71-.297Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h20v20H0z" />
			</clipPath>
		</defs>
	</svg>
);
